var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "1155 565 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 867"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1162 565h21a7 7 0 0 1 7 7v21a7 7 0 0 1-7 7h-21a7 7 0 0 1-7-7v-21a7 7 0 0 1 7-7z",
    fillRule: "evenodd",
    "data-name": "Rectangle 992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.541 574.57h-1.568v1.568h1.568v-1.568Zm-2.351 8.62h-1.568a.784.784 0 0 0 0 1.568h1.568a.784.784 0 0 0 0-1.567Zm-.784-5.486c.433 0 .784-.35.784-.783v-3.136a.784.784 0 0 0-1.567 0v3.136c0 .432.35.783.783.783Zm5.487 8.623h-1.568a.784.784 0 0 0 0 1.567h1.568a.784.784 0 0 0 0-1.567Zm0-3.136h-1.568a.784.784 0 0 0 0 1.567h1.568a.784.784 0 0 0 0-1.567Zm-.784-5.487c.433 0 .784-.35.784-.783v-3.136a.784.784 0 0 0-1.567 0v3.136c0 .432.35.783.783.783Zm-.783 3.92h1.568a.784.784 0 0 0 0-1.567h-1.568a.784.784 0 0 0 0 1.567Zm-4.703 0h1.568a.784.784 0 0 0 0-1.567h-1.568a.784.784 0 0 0 0 1.567Zm-3.136 4.702h-1.568a.784.784 0 0 0 0 1.567h1.568a.784.784 0 0 0 0-1.567Zm11.758-11.757h-1.567v1.568h1.567v14.109h-15.677v-14.11h1.568v-1.567h-1.568c-.866 0-1.567.702-1.567 1.568v14.11c0 .865.702 1.567 1.567 1.567h15.677c.866 0 1.568-.702 1.568-1.568v-14.11c0-.865-.702-1.566-1.568-1.566Zm-11.758 8.622h-1.568a.784.784 0 0 0 0 1.566h1.568a.784.784 0 0 0 0-1.566Zm2.352-8.622h-1.567v1.568h1.567v-1.568Zm2.351 11.757h-1.568a.784.784 0 0 0 0 1.567h1.568a.784.784 0 0 0 0-1.567Zm-6.271-4.702h1.568a.784.784 0 0 0 0-1.567h-1.568a.784.784 0 0 0 0 1.567Zm.785-3.92c.432 0 .783-.35.783-.783v-3.136a.784.784 0 0 0-1.568 0v3.136c0 .432.352.783.785.783Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "noun-calendar-1585329"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d202e5d8e83dd44f4ae9b3cf2bb183ef.svg";
export { ForwardRef as ReactComponent };